import React from 'react';
import Routing from './Routes';

import './assets/scss/style.scss'
import 'react-toastify/dist/ReactToastify.css';

import { JobProvider } from "./context/JobContext";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ToastContainer } from 'react-toastify';

// REPLACE THIS WITH YOUR ACTUAL CLIENT ID
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID 

function App() {
  return (
    <React.Fragment>
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID as string}>
        <JobProvider>
          <Routing />
          <ToastContainer />
        </JobProvider>
      </GoogleOAuthProvider>
    </React.Fragment>
  );
}

export default App;
